import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import CU from "@/utils/c-u";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {ListView} from "@/scenes.ui/list-view";
import Container = Phaser.GameObjects.Container;
import {Creature} from "@/store/level/types";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";

export class CreatureSelectPanel extends VerticalStandardPanel {
    private static HEROES_IN_ROW = 4;
    private listView!: ListView | null;

    constructor(scene: Scene, canvas: HTMLCanvasElement, callback: (creatureIndex: number) => void, creaturesList: Creature[], title: string = Tr('vashi.geroi')) {
        super(scene, canvas, title);
        let self = this;
        let listPanelContainer: Container[] = [];
        let rowContainers: Container[] = [];
        creaturesList.forEach((c, i) => {
            let row = Math.floor(i / CreatureSelectPanel.HEROES_IN_ROW);
            if (!rowContainers[row]) {
                rowContainers[row] = new Container(scene, 0, 0);
                listPanelContainer.push(rowContainers[row]);
                rowContainers[row].height = 180;
            }
            let panel: CreaturePanel = new CreaturePanel(scene, -150 + (i % CreatureSelectPanel.HEROES_IN_ROW) * 105, 70, c, () => {
            }, true);
            panel.height = 0;
            panel.setHealthVisible();
            panel.setSmallClickAreaCallback(c, () => {
                callback(i);
                self.onClose();
            });
            rowContainers[row].add(panel);
        });
        let listView: ListView = new ListView(scene, canvas, listPanelContainer, -canvas.width / 2 + 362 * CU.S, canvas.height / 2 - 250 * CU.S, 460 * CU.S, 500 * CU.S);
        listView.height = rowContainers.length * 200 / CU.S;
        this.listView = listView;
        this.scene.add.existing(listView);
        listView.setDepth(3002);
        this.on('destroy', function () {
            if (self.listView) self.listView.destroy();
        });
    }

    protected onClose() {
        this.listView?.destroy();
        this.listView = null;
        super.onClose();
    }

}
